import Head from "next/head";
import type {NextPage} from "next";
import {useCookies} from "react-cookie";
import {handleLogout} from "components/utils"; import React, {useEffect, useState} from "react";
import {RadiologyView} from "../components/diagnostics/radiology/RadiologyView";

const Radiology: NextPage = (props) => {

    const [cookies] = useCookies(['qme']);
    const cookieEntityQr = cookies.qme ? cookies.qme["entity_qr"] : null

    return (
        <div>
            <Head>
                <title>QMe - Radiology</title>
                <meta name="description" content="QMe - Radiology"/>
                <meta name="keywords" content="electronic medical records software, EMR Software, EHR, opd management software"/>
                <meta name="robots" content="noindex, nofollow"/>
            </Head>
            <div className="bg-white"><RadiologyView cookieEntityQr={cookieEntityQr}/></div>
        </div>
    );
};


export default Radiology;
